import { FC } from "react";
import HousingHistoryTierLightIcon from "../assets/housing-history-tier-light.svg?react";
import HousingHistoryTierPremiumIcon from "../assets/housing-history-tier-premium.svg?react";

export const HousingHistoryTierPill: FC<{ isPremium: boolean }> = ({
  isPremium
}) => {
  return (
    <span className="inline-flex items-center gap-1 rounded-md border border-alpha-100 bg-white px-1.5 py-1 text-[10px] font-medium leading-4 text-content-700">
      {isPremium ? (
        <HousingHistoryTierPremiumIcon
          className="size-3 shrink-0"
          aria-hidden
        />
      ) : (
        <HousingHistoryTierLightIcon className="size-3 shrink-0" aria-hidden />
      )}
      {isPremium ? "Premium" : "Lite"}
    </span>
  );
};
